// Rudementary way of creating Daily challenges
// TODO: Host this data somwewhere else and replace with an API call
const dailyLetters = [
  'p',
  'r',
  'q',
  'r',
  'p',
  's',
  'o',
  'x',
  'g',
  'b',
  'm',
  'x',
  'p',
  'm',
  'z',
  'r',
  'a',
  'f',
  'n',
  'x',
  'q',
  'w',
  'n',
  'x',
  'o',
  'b',
  'y',
  'v',
  'o',
  'i',
  'p',
  't',
  'j',
  'w',
  'o',
  'y',
  't',
  'k',
  'q',
  'k',
  'i',
  's',
  'v',
  'a',
  'h',
  'z',
  'q',
  't',
  'c',
  'y',
  'o',
  'v',
  'b',
  'h',
  'w',
  'n',
  'a',
  'e',
  'x',
  'c',
  'b',
  'q',
  'k',
  'w',
  'z',
  'w',
  'c',
  'p',
  'g',
  'c',
  'b',
  'i',
  'e',
  'r',
  'x',
  'e',
  'f',
  'c',
  'p',
  'r',
  'y',
  'n',
  'g',
  'b',
  'r',
  's',
  'j',
  'i',
  'i',
  'a',
  's',
  'd',
  'a',
  'd',
  'n',
  'a',
  'n',
  'm',
  'w',
  'z',
  'h',
  'k',
  'd',
  'n',
  'a',
  'i',
  'p',
  'z',
  'h',
  'd',
  'm',
  'o',
  'b',
  'a',
  'y',
  'x',
  'j',
  'c',
  't',
  'z',
  'n',
  'r',
  'n',
  'q',
  'u',
  'y',
  'n',
  'x',
  'f',
  'z',
  'n',
  'v',
  'd',
  'z',
  'i',
  'd',
  'p',
  'y',
  'y',
  'g',
  'a',
  'l',
  'y',
  'l',
  's',
  'd',
  'u',
  'f',
  'f',
  'l',
  'c',
  'c',
  'o',
  'z',
  'x',
  'g',
  'x',
  'm',
  'm',
  'f',
  'c',
  's',
  'p',
  'g',
  'd',
  'k',
  'c',
  'v',
  'v',
  'c',
  'n',
  'w',
  'c',
  'x',
  'w',
  'd',
  'e',
  'x',
  't',
  'w',
  'i',
  'l',
  'g',
  'v',
  'u',
  'z',
  'm',
  'l',
  'e',
  'c',
  'o',
  'n',
  'r',
  'n',
  'f',
  'a',
  'c',
  'c',
  'p',
  'b',
  't',
  'k',
  'n',
  'w',
  'd',
  'l',
  'w',
  'q',
  'g',
  'h',
  'r',
  'n',
  'k',
  'h',
  'h',
  'g',
  'h',
  'k',
  'y',
  'o',
  'p',
  'w',
  'v',
  'g',
  'u',
  'y',
  'j',
  't',
  'x',
  'j',
  'd',
  'r',
  'e',
  'q',
  'e',
  'u',
  'a',
  'm',
  'f',
  'c',
  'k',
  'w',
  'c',
  'n',
  'e',
  'r',
  'v',
  'a',
  'n',
  'g',
  'd',
  'u',
  'j',
  'e',
  'j',
  'm',
  'c',
  't',
  'f',
  'a',
  'y',
  'd',
  'e',
  'p',
  'y',
  'l',
  'q',
  't',
  'v',
  'j',
  'u',
  'r',
  'j',
  'g',
  'a',
  'y',
  'e',
  'p',
  'y',
  'f',
  'n',
  'e',
  'l',
  'f',
  'h',
  'v',
  'c',
  'i',
  'e',
  'z',
  'x',
  'm',
  's',
  'z',
  'y',
  'd',
  'j',
  'k',
  'b',
  'r',
  'a',
  'e',
  'k',
  's',
  'u',
  'y',
  'r',
  'r',
  'e',
  't',
  'c',
  'f',
  'o',
  'z',
  'j',
  'i',
  'o',
  't',
  'o',
  'n',
  'o',
  'e',
  'l',
  'g',
  'l',
  's',
  'z',
  'z',
  'k',
  'l',
  'f',
  'a',
  'd',
  'p',
  'q',
  'z',
  'f',
  'k',
  'u',
  'v',
  'w',
  'h',
  'c',
  'm',
  'x',
  'w',
  's',
  'd',
  'p',
  'k',
  'l',
  'u',
  'o',
  'h',
  'm',
  'a',
  'z',
  'r',
  'd',
  'b',
  'z',
  'c',
  'b',
  'o',
  'v',
];

export default dailyLetters;
